{
    "productDashboard": {
        "common": {
            "last": "Senaste",
            "for": "Under",
            "days": "dagar",
            "day": "dag",
            "categories": "kategorier",
            "open": "Öppen",
            "inProgress": "Pågår",
            "inProgressShort": "Pågår",
            "resolved": "Löst",
            "clear": "Rensa",
            "selected": "valda",
            "clearAllFilters": "Rensa alla filter"
        },
        "shell": {
            "dataUpdated": "Data uppdaterad",
            "latestTurn": "senaste interaktion",
            "records": "poster",
            "ofData": "av data",
            "syncing": "Synkroniserar…",
            "refresh": "↻ Uppdatera data",
            "dataRefreshed": "Data har uppdaterats.",
            "syncFailed": "Synkroniseringen kunde inte startas.",
            "syncCompletedWithErrors": "Synkroniseringen slutfördes med fel:",
            "timeRangeAria": "Tidsintervall",
            "overview": "Översikt",
            "myhelpData": "från MyHelp-data",
            "rangeLabel": "Intervall",
            "rangeAria": "Anpassat datumintervall",
            "rangeFrom": "Från",
            "rangeTo": "Till",
            "rangeApplyAria": "Använd datumintervall",
            "rangeClearAria": "Rensa datumintervall",
            "rangeSelectBoth": "Välj både ett start- och slutdatum.",
            "rangeInvalidOrder": "Startdatumet måste vara före slutdatumet.",
            "rangeTooWide": "Välj ett intervall på upp till",
            "dateRangeCaption": "Datumintervall"
        },
        "overview": {
            "greetingMorning": "God morgon",
            "greetingAfternoon": "God eftermiddag",
            "greetingEvening": "God kväll",
            "greetingNight": "God natt",
            "subtitle": "Här är vad som händer med dina produkter idag.",
            "tabOverview": "Översikt",
            "tabActionsForYou": "Åtgärder för dig",
            "actionsTitle": "Åtgärder för dig",
            "actionsMeta": "Rekommenderade nästa steg för produktteamet",
            "kpiTotalQueries": "TOTALT ANTAL FRÅGOR",
            "kpiIncidentsRaised": "RAPPORTERADE INCIDENTER (Sedan 10 september)",
            "kpiUpcoming": "KOMMANDE FUNKTION",
            "kpiCallback": "ÅTERUPPRINGNINGSFÖRFRÅGNINGAR (Sedan 10 september)",
            "kpiLiveChat": "LIVECHATTFÖRFRÅGNINGAR (Sedan 10 september)",
            "viewBreakdown": "Nedbrytning →",
            "viewAllIncidents": "Alla incidenter →",
            "upcomingTitle": "Ny funktion kommer snart",
            "upcomingSub": "Fler produktinsikter är på väg.",
            "topCategories": "Vanligaste frågekategorierna",
            "viewAll": "Visa alla →",
            "tipQueries": "Frågor",
            "uniqueUsersTitle": "Unika användare",
            "detailedView": "Detaljerad vy",
            "usersPerDay": "Unika användare per dag",
            "usersPerWeek": "Unika användare per vecka",
            "usersPerMonth": "Unika användare per månad",
            "uniqueUsersTrendTooltipLead": "Jämför",
            "uniqueUsersTrendTooltipConnector": "med",
            "kpiTooltips": {
                "totalQueries": "Totalt antal frågor som mottagits för alla produkter under den valda tidsperioden.",
                "incidentsRaised": "Incidenter som rapporterats från chattbottskonversationer, uppdelade efter status.",
                "upcoming": "En ny instrumentpanelsfunktion är på väg — kom tillbaka snart.",
                "callback": "Återuppringningsförfrågningar som skickats in av användare, uppdelade efter språk.",
                "liveChat": "Livechattförfrågningar som skickats in av användare, uppdelade efter språk.",
                "feedbackCoverage": "Andel av det totala antalet frågor som fått användarfeedback (👍 eller 👎)."
            }
        },
        "totalQueries": {
            "title": "Insikter om totalt antal frågor",
            "queries": "frågor",
            "vsPrior": "jämfört med föregående period",
            "chartTitle": "Frågor per kategori",
            "breakdownTitle": "Nedbrytning per kategori",
            "thCategory": "KATEGORI",
            "thQueries": "FRÅGOR",
            "thShare": "ANDEL",
            "thDistribution": "FÖRDELNING",
            "tipQueries": "Frågor",
            "tipShare": "Andel %",
            "searchPlaceholder": "Sök",
            "matchesSuffix": "träffar",
            "matchSuffix": "träff"
        },
        "incidents": {
            "title": "Problemkategorier",
            "incidents": "incidenter",
            "thId": "ID",
            "thIssue": "FRÅGA / PROBLEM",
            "thCategory": "KATEGORI",
            "thProduct": "PRODUKT",
            "thCompany": "FÖRETAG",
            "thSeverity": "ALLVARLIGHETSGRAD",
            "thStatus": "STATUS",
            "empty": "Inga MyHelp-incidenter under denna period.",
            "severityHigh": "Hög",
            "severityMedium": "Medel",
            "severityLow": "Låg",
            "incident": "incident",
            "breakdownTitle": "Kategoriuppdelning",
            "thIncidents": "INCIDENTER",
            "thShare": "ANDEL",
            "thDistribution": "FÖRDELNING",
            "searchPlaceholder": "Sök",
            "matchesSuffix": "träffar",
            "matchSuffix": "träff"
        },
        "incidentCategory": {
            "titlePrefix": "Incidenter i",
            "loadError": "Det gick inte att läsa in incidenter.",
            "incident": "incident",
            "incidents": "incidenter",
            "closeAria": "Stäng",
            "thDate": "DATUM",
            "empty": "Inga incidenter hittades för denna kategori.",
            "loading": "Läser in…",
            "loadMorePrefix": "Läs in fler (visar",
            "of": "av"
        },
        "userSentiment": {
            "title": "Insikter om användarfeedback",
            "summaryLikes": "gillamarkeringar",
            "summaryDislikes": "ogillamarkeringar",
            "last": "Senaste",
            "days": "dagar",
            "likes": "Gillar",
            "dislikes": "Ogillar",
            "chartTitle": "Gillar vs. ogillar per kategori",
            "detailTitle": "Detaljerad feedback per kategori",
            "positive": "Positiv",
            "thingsWell": "Vad som fungerade bra",
            "thingsAttention": "Vad som behöver uppmärksamhet",
            "askAiHint": "Fråga AI-assistenten om detta (öppnas i en ny flik)",
            "searchPlaceholder": "Sök",
            "matchesSuffix": "träffar",
            "matchSuffix": "träff"
        },
        "products": {
            "title": "Produktkategorier",
            "products": "produkter",
            "queryVolume": "Frågevolym",
            "incidents": "Incidenter",
            "sentiment": "Sentiment",
            "healthScore": "Hälsopoäng"
        },
        "companyFilter": {
            "allCompanies": "Alla företag",
            "allCompaniesShort": "Alla företag",
            "selectedSuffix": "företag valda",
            "filterAria": "Filtrera efter företag",
            "searchPlaceholder": "Sök företag…",
            "noMatchPrefix": "Inga företag matchar"
        },
        "clusterFilter": {
            "allClusters": "Alla kluster",
            "allClustersShort": "Alla kluster",
            "selectedSuffix": "kluster valda",
            "filterAria": "Filtrera efter kluster",
            "searchPlaceholder": "Sök kluster…",
            "noMatchPrefix": "Inga kluster matchar"
        },
        "categoryFilter": {
            "allCategories": "Alla kategorier",
            "selectedSuffix": "kategorier valda",
            "filterAria": "Filtrera efter kategori",
            "searchPlaceholder": "Sök kategorier…",
            "allCategoriesShort": "Alla kategorier",
            "selectedShort": "valda",
            "clear": "Rensa",
            "noMatchPrefix": "Inga kategorier matchar"
        },
        "categoryQueries": {
            "like": "Gilla",
            "dislike": "Ogilla",
            "titlePrefix": "Frågor i",
            "loadError": "Det gick inte att läsa in frågorna.",
            "query": "fråga",
            "queries": "frågor",
            "preparing": "Förbereder…",
            "downloadExcel": "⬇ Ladda ner Excel",
            "closeAria": "Stäng",
            "thQuery": "FRÅGA",
            "thSentiment": "SENTIMENT",
            "thDate": "DATUM",
            "thSource": "KÄLLA",
            "thLanguage": "SPRÅK",
            "thCompany": "FÖRETAG",
            "colQuery": "Fråga",
            "colSentiment": "Sentiment",
            "colDate": "Datum",
            "colSource": "Källa",
            "colLanguage": "Språk",
            "colCompany": "Företag",
            "empty": "Inga frågor hittades för denna kategori.",
            "loading": "Läser in…",
            "loadMorePrefix": "Läs in fler (visar",
            "of": "av",
            "sortSentimentHint": "Klicka för att sortera efter sentiment",
            "sortDateHint": "Klicka för att sortera efter datum"
        },
        "feedbackPie": {
            "likes": "Gillar",
            "dislikes": "Ogillar",
            "noFeedback": "Ingen feedback",
            "coverage": "FEEDBACKTÄCKNING",
            "meta": "av totalt antal frågor",
            "feedback": "feedback",
            "noData": "Ingen data",
            "viewFeedback": "Användarfeedback →"
        },
        "requestCard": {
            "empty": "Inga förfrågningar under denna period.",
            "breakdown": "Uppdelning →"
        },
        "requestBreakdown": {
            "titleCallback": "Återuppringningsförfrågningar — Språkuppdelning",
            "titleLiveChat": "Livechattförfrågningar — Språkuppdelning",
            "breakdownTitle": "Språkuppdelning",
            "thLanguage": "SPRÅK",
            "thCount": "ANTAL",
            "thShare": "ANDEL",
            "thDistribution": "FÖRDELNING",
            "language": "språk",
            "languages": "språk",
            "request": "förfrågan",
            "requests": "förfrågningar",
            "empty": "Inga förfrågningar under denna period."
        },
        "tabError": {
            "title": "Det gick inte att läsa in instrumentpanelens data",
            "message": "Datatjänsten svarade inte. Försök igen — ingen data visas så inget här är uppskattat."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Skapa / uppdatera kunskapsartiklar",
                "hint": "Håll din produkts innehåll korrekt och aktuellt",
                "childTitle": "Skapa och uppdatera kunskapsbasen",
                "childHint": "Så här skapar och uppdaterar du kunskapsbasen."
            },
            "scripts": {
                "title": "Bygg och distribuera skript via Nexthink Remote Actions",
                "hint": "Automatisera åtgärden genom att aktivera en fjärråtgärd på användarens enhet",
                "childTitle": "Länk för att beställa Nexthink",
                "childHint": "Hantering av fjärråtgärder"
            }
        }
    }
}
